import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';

// Aus cardList.jsx extrahiert — dort war die Paginierung bereits fertig, aber
// als 100-Zeilen-Block inline. Jetzt teilen sich alle drei Admin-Listen diese
// eine Komponente.

const MAX_VISIBLE_PAGES = 5;

const getPageNumbers = (currentPage, numOfPages) => {
  let startPage = Math.max(
    1,
    currentPage - Math.floor(MAX_VISIBLE_PAGES / 2)
  );
  const endPage = Math.min(numOfPages, startPage + MAX_VISIBLE_PAGES - 1);

  if (endPage - startPage + 1 < MAX_VISIBLE_PAGES) {
    startPage = Math.max(1, endPage - MAX_VISIBLE_PAGES + 1);
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) pages.push(i);
  return pages;
};

const Pagination = ({ currentPage, numOfPages, total, limit, onPageChange }) => {
  if (!numOfPages || numOfPages <= 1) return null;

  const firstOnPage = (currentPage - 1) * limit + 1;
  const lastOnPage = Math.min(currentPage * limit, total);

  return (
    <div className="mt-6 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Zurück
        </button>
        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= numOfPages}
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Weiter
        </button>
      </div>

      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <p className="text-sm text-gray-700">
          Zeige <span className="font-medium">{firstOnPage}</span> bis{' '}
          <span className="font-medium">{lastOnPage}</span> von{' '}
          <span className="font-medium">{total}</span> Ergebnissen
        </p>

        <nav
          className="isolate inline-flex -space-x-px rounded-md shadow-sm"
          aria-label="Paginierung"
        >
          <button
            type="button"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage <= 1}
            className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span className="sr-only">Vorherige</span>
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
          </button>

          {getPageNumbers(currentPage, numOfPages).map((pageNum) => (
            <button
              key={pageNum}
              type="button"
              onClick={() => onPageChange(pageNum)}
              aria-current={pageNum === currentPage ? 'page' : undefined}
              className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                pageNum === currentPage
                  ? 'z-10 bg-svisit-primary-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600'
                  : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
              }`}
            >
              {pageNum}
            </button>
          ))}

          <button
            type="button"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage >= numOfPages}
            className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span className="sr-only">Nächste</span>
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
